import React, { useState } from 'react';
import { Phone, X, Zap } from 'lucide-react';
import { Button } from '../ui/button';

export const Header = () => {
  const [showPromoBar, setShowPromoBar] = useState(true);

  const scrollToPromo = () => {
    const el = document.getElementById('promo-section');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {showPromoBar && (
        <div data-testid="promo-bar" className="fixed top-0 left-0 right-0 bg-gradient-to-r from-[#0A0E27] via-[#0066FF] to-[#00D9FF] text-white py-3 px-4 z-50 shadow-2xl border-b border-cyan-400/30">
          <div className="container mx-auto flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Zap className="w-5 h-5 text-yellow-300" />
              <span className="font-bold text-lg">R499 Service Special</span>
              <span className="hidden sm:inline text-cyan-100">Professional Aircon Service &bull; Limited Slots</span>
            </div>
            <div className="flex items-center space-x-3">
              <Button size="sm" className="bg-white text-[#0A0E27] hover:bg-cyan-50 font-bold shadow-lg" onClick={scrollToPromo}>
                Book Now
              </Button>
              <button onClick={() => setShowPromoBar(false)} className="text-white hover:text-cyan-200 transition-colors">
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      )}

      <header data-testid="main-header" className={`fixed ${showPromoBar ? 'top-12' : 'top-0'} w-full bg-[#0A0E27]/95 backdrop-blur-xl shadow-lg shadow-black/20 z-40 transition-all duration-300 border-b border-white/5`}>
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img
                src="/logo-transparent.png"
                alt="Chill Point Logo"
                className="h-12 w-auto"
              />
            </div>
            <nav className="hidden md:flex items-center space-x-6">
              {['Services', 'About', 'Testimonials', 'FAQ', 'Contact'].map((item) => (
                <a key={item} href={`#${item.toLowerCase()}`} className="text-gray-300 hover:text-[#00D9FF] transition-colors font-medium text-sm uppercase tracking-wider">
                  {item}
                </a>
              ))}
            </nav>
            <div className="flex items-center space-x-3">
              <a href="tel:0644505026" className="hidden sm:flex items-center space-x-2 text-[#00D9FF] font-semibold hover:text-white transition-colors">
                <Phone className="w-4 h-4" />
                <span>064 450 5026</span>
              </a>
              <Button className="bg-gradient-to-r from-[#0066FF] to-[#00D9FF] hover:from-[#0052CC] hover:to-[#00B8D4] text-white shadow-lg shadow-blue-500/25 font-bold">
                <a href="#contact">Get Quote</a>
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Spacer for fixed header */}
      <div className={showPromoBar ? 'h-[108px]' : 'h-[72px]'} />
    </>
  );
};
